import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Login from "./Login";
import RequireAuth from "./RequireAuth";
import Layout from "./Layout";
import { setAuthToken } from "./api";
import HolidaysRequest from "./Holidays_request";
import Users from "./Users";
import RequestResetPassword from "./RequestResetPassword";
import ResetPassword from "./ResetPassword";
import AdminApproval from "./AdminApproval";
import UserHolidayRequests from "./UserHolidayRequests";
import Departments from "./Department";
import Planning from "./Planning";
import SicknessLogs from "./SicknessLogs";
import AllUsersListHolidays from "./AllUsersListHolidays";
import AddHolidayRequest from "./Add_Holidays_Request";
import SicknessSummary from "./SicknessSummary";
import CancelHolidayRequests from "./CancelHolidayRequests";
import AppointmentLogs from "./AppointmentLogs";
import BulkHolidayRequest from "./BulkHolidayRequest";
import PublicHolidays from "./PublicHolidays";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userString = localStorage.getItem("user");
    const user = userString ? JSON.parse(userString) : null;
    if (token && user) {
      setAuthToken(token);
      setIsAuthenticated(true);
      setUserRole(user.role);
    }
    setLoading(false);
  }, []);

  const handleLogin = (token, user) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
    setAuthToken(token);
    setIsAuthenticated(true);
    setUserRole(user.role);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setAuthToken(null);
    setIsAuthenticated(false);
    setUserRole(null);
  };

  // Pendant le chargement, on peut afficher un indicateur
  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route path="/reset_password" element={<RequestResetPassword />} />
        <Route path="/reset_password/:token" element={<ResetPassword />} />
        <Route element={<RequireAuth isAuthenticated={isAuthenticated} />}>
          <Route path="/" element={<Layout handleLogout={handleLogout} />}>
            <Route path="/holidays-request" element={<HolidaysRequest />} />
            <Route
              path="/list-holidays-request"
              element={<UserHolidayRequests />}
            />
            {userRole === "Global Administrator" && (
              <Route
                path="/allUsersListHolidays"
                element={<AllUsersListHolidays />}
              />
            )}
            {userRole === "Global Administrator" && (
              <Route path="/add-holidays" element={<AddHolidayRequest />} />
            )}
            {userRole === "Global Administrator" && (
              <Route path="/users" element={<Users />} />
            )}
            {userRole === "Global Administrator" && (
              <Route path="/departments" element={<Departments />} />
            )}
            {userRole === "Global Administrator" && (
              <Route path="/publicHolidays" element={<PublicHolidays />} />
            )}
            {userRole === "Global Administrator" && (
              <Route path="/admin-approval" element={<AdminApproval />} />
            )}
            {userRole === "Global Administrator" && (
              <Route path="/planning" element={<Planning />} />
            )}
            {(userRole === "Global Administrator" ||
              userRole === "Sickness User") && (
              <Route path="/sickness-logs" element={<SicknessLogs />} />
            )}
            {userRole === "Global Administrator" && (
              <Route
                path="/sickness-summary"
                element={<SicknessSummary year={2025} />}
              />
            )}
            {userRole === "Global Administrator" && (
              <Route
                path="/cancel-requests"
                element={<CancelHolidayRequests />}
              />
            )}
            {userRole === "Global Administrator" && (
              <Route path="/appointment-logs" element={<AppointmentLogs />} />
            )}
            {userRole === "Global Administrator" && (
              <Route
                path="/bulk-holiday-request"
                element={<BulkHolidayRequest />}
              />
            )}
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
};

export default App;
